import { render, staticRenderFns } from "./column-chooser-button.vue?vue&type=template&id=796f0b2c&lang=html"
import script from "./column-chooser-button.vue?vue&type=script&lang=js"
export * from "./column-chooser-button.vue?vue&type=script&lang=js"
import style0 from "./column-chooser-button.vue?vue&type=style&index=0&id=796f0b2c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports